import { Module } from 'vuex';
import { NodeDomainAccountState } from './types';
import { RootState } from '../../../types';
import { actions } from './actions';
import { mutations } from './mutations';

export const state: NodeDomainAccountState = {
    domainAccounts: undefined,
    domainAccountCount: 0,
    search: {
        isProcessing: false,
        isFetchSuccess: false,
        error: false,
        errorCode: undefined,
        errorMsg: undefined,
    },
    create: {
        isProcessing: false,
        error: false,
        errorTitle: undefined,
        errorDetails: undefined,
    },
    destroy: {
        isProcessing: false,
        error: false,
        errorTitle: undefined,
        errorDetails: undefined,
    },
};

const namespaced: boolean = true;

export const nodeDomainAccount: Module<NodeDomainAccountState, RootState> = {
    namespaced,
    state,
    actions,
    mutations,
};
